import { useNotification } from '@/containers'
import type { ImageProps } from 'next/image'
import Image from 'next/image'

import type { StaticImport } from 'next/dist/shared/lib/get-img-props'
const isSvg = (src: string | StaticImport): boolean => {
  if (typeof src !== 'string') return false
  return src.trim().toLowerCase().endsWith('.svg')
}

const ImageOptimize = ({
  alt,
  thumbnail = false,
  lazyLoad = true,
  ...rest
}: ImageProps & {
  alt: string
  thumbnail?: boolean
  lazyLoad?: boolean
}) => {
  const { systemConfig } = useNotification()
  const qtt =
    systemConfig?.imageQlt && systemConfig?.imageQlt != ''
      ? systemConfig?.imageQlt
      : 70
  const width =
    systemConfig?.imageThumbWidthMobile &&
    systemConfig?.imageThumbWidthMobile != ''
      ? systemConfig?.imageThumbWidthMobile
      : 275
  const thumbParam = thumbnail ? `&width=${width}` : ''

  const baseSrc =
    rest.src && typeof rest.src === 'string'
      ? rest.src
      : systemConfig?.imagePlaceholder ||
        process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
        ''

  const srcWithParams =
    isSvg(baseSrc) || baseSrc.includes('format=webp')
      ? baseSrc + (thumbnail ? `?${thumbParam.slice(1)}` : '')
      : baseSrc + `?format=webp&quality=${qtt}${thumbParam}`
  return (
    <Image
      {...rest}
      className={`${rest.className ?? ''} imgOtm`}
      alt={alt || systemConfig?.websiteBrandName || ''}
      width={rest.width ?? 0}
      height={rest.height ?? 0}
      sizes='100%'
      src={srcWithParams}
      loading={rest.priority ? 'eager' : lazyLoad ? 'lazy' : 'eager'}
    />
  )
}
export default ImageOptimize
